import React from "react";
import "../../css/insightsView.css";
import "../../css/insightsOneView.css";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import { insightsConstants } from "../../constant/insights_constants";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import $ from "jquery";
import MediaQuery from "react-responsive";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPlayer from "react-player";
import emailForwardIcon from "../../images/icons/send-mail-icon.jpg";
import MailForwardForm from "../../components/MailForwardForm";

const icon1 = "https://winpeforum.com/assets/elements/Priya-Rajan.jpg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
      style={{ margin: "0% auto 0px" }}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">{activeItem.post}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};
TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class PriyaRajan extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
      activeKeyword: "",
      isSearching: false,
      lastCounter: 3,
      activeTitle: "SORT BY",
      activeSortBy: "default",
      showMailShareForm: false,
    };
    this.betterContent = insightsConstants;
    this.TabContent = [
      // {
      // 	title: "POPULARITY",
      // },
      {
        title: "ALL",
      },
      {
        title: "BLOGS",
      },
      {
        title: "INFOGRAPHICS",
      },
      {
        title: "INTERVIEWS",
      },
      {
        title: "VIDEOS",
      },
    ];
    this.Speaker = [
      {
        desc: `<div>Priya is Market Lead for India and MENA in SVB’s international market development
        team, Global Gateway. She provides market entry advice and insights on cross-border
        engagement focused on constituents in the innovation ecosystem – founders and
        investors.  <br/><br/>
         
        Priya’s work with Indian entrepreneurs and venture capital funds has yielded tangible
        value with founders accessing leading programs in the U.S. like Y-Combinator and
        investors getting visibility of great founders and deals.  <br/><br/>
         
        Priya calls on her experience, expertise and connections to champion a more inclusive
        innovation economy. She works closely with community leaders, including Change
        Catalyst, Kapor Capital, and YC Female Founders. She sits on the board of directors at
        non-profits Big Brothers Big Sisters and Women Who Code – an organization dedicated
        to helping women excel in technology careers. As a venture partner at Xfund, Priya
        connects VC firms with superior research universities and advisor at Entrepreneurship
        at Cornell University. <br/><br/>
         
        Priya co-created the Diaspora Community initiative at SVB and is a charter member
        of TiE, a nonprofit focused on nurturing the next generation of entrepreneurs with Indian
        ties.  <br/><br/>
         
        Prior to joining Global Gateway, Priya was a Director in our early stage practice (Startup
        Banking) where she led university programs and SVB Trek for student entrepreneurs.
        Leading to partnerships with Dorm Room Fund, The House Fund, Stanford Venture
        Studio and Rough Draft Ventures. <br/><br/>
         
        Priya’s career at SVB Financial Group began as a global group financial officer, a
        pivotal role in the Finance team. Earlier in her career, she held financial management
        positions at Charles Schwab and Enterprise Rent-A-Car. In addition to a bachelor’s
        degree from the University of Madras and a master’s degree in international business
        from Queen’s University, Priya holds an MBA in business administration from Cornell
        University and a California CPA in accounting and business administration. <br/><br/>
         
         
        
        Priya enjoys travelling the world, opening doors, and meeting new people. When not on
        a plane, Priya enjoys classical music – after studying music for over a decade, she
        passed on this passion and skill to her two children.
        .
        
        
        
        </div>`,
        name: "Priya Rajan",
        post: "Market Lead for India and MENA, Silicon Valley Bank",
        imgUrl: icon1,
        head: "Vested in Innovation",
      },
    ];
  }
  componentDidMount() {
    // function sticky_relocate () {
    // 	var window_top = $(window).scrollTop()
    // 	var div_top = $("#sticky-anchor").offset().top
    // 	if (window_top > div_top) {
    // 		$("#sticky").addClass("stick")
    // 	} else {
    // 		$("#sticky").removeClass("stick")
    // 	}
    // }
    // $(function () {
    // 	$(window).scroll(sticky_relocate)
    // 	sticky_relocate()
    // })
  }

  toggleMailShareForm = () => {
    this.setState({ showMailShareForm: !this.state.showMailShareForm });
  };

  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  handleMenu = (item) => {
    this.setState({
      activeTitle: item.title,
    });

    let leftlist = [...insightsConstants];
    this.betterContent = [];
    if (item.title === "SORT BY") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else if (item.title === "ALL") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else {
      []
        .concat(leftlist)
        .filter((insight) => {
          console.log(insight);
          // a.typee.indexOf(item.title) >= 0}
          let flag = false;
          for (let i = 0; i < insight.itype.length; i++) {
            if (item.title === insight.itype[i]) {
              flag = true;
            }
          }
          return flag;
        })
        .forEach((item, i) => this.betterContent.push(item));
    }
    this.setState({
      activeSortBy: item.title,
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleSearch = (e) => {
    let str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    let leftlist = [...insightsConstants];
    this.betterContent = [];
    leftlist.forEach((item) => {
      if (
        item.skey
          .toLowerCase()
          .trim()
          .search(str) > -1
      ) {
        this.betterContent.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  render() {
    const leftList = this.betterContent.filter(
      (item) => item.url !== "/PriyaRajan"
    );

    const {
      defaultStyle,
      isSearching,
      isShow,
      activeTitle,
      activeSortBy,
    } = this.state;
    const { location } = this.props;
    return (
      <div>
        <MailForwardForm
          show={this.state.showMailShareForm}
          onClickClose={this.toggleMailShareForm}
          url={"insights.php/forward"}
          insight="Vested in Innovation"
        />
        <ContentPage>
          <Meta
            title="Winpe Insights | Vested in Innovation            "
            image={
              "https://winpeforum.com/assets/elements/priya-thumb.jpg"
            }
            description="Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank. Having witnessed its evolution across markets and regions, she shares her insights into what drives entrepreneurial success and why the Indian VC market is exciting for investors.             "
            location={location}
            keywords=""
          />
          <Meta
            title="Winpe Insights | Vested in Innovation "
            image={
              "https://winpeforum.com/assets/elements/priya-thumb.jpg"
            }
            description="Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank. Having witnessed its evolution across markets and regions, she shares her insights into what drives entrepreneurial success and why the Indian VC market is exciting for investors.             "
            location={location}
            keywords=""
          />
          <div className="section__content">
            <div className="insights_wrapper">
              <div className="insights_section">
                <MediaQuery query="(min-width: 768px)">
                  <div className="insights_main_heading">
                    <div className="left_line"></div>
                    <div className="insights_main_heading_text">
                      Winpe INSIGHTS
                    </div>
                  </div>
                </MediaQuery>
                <MediaQuery
                  query="(min-width: 767px)"
                  style={{ display: "none" }}
                >
                  <div className="insights_main_heading"></div>
                </MediaQuery>
                <div className="insights_content">
                  <div className="drop_src_box">
                    <MediaQuery query="(min-width: 768px)">
                      <div className="left_drop_box">
                        <DropdownButton title={activeTitle}>
                          {this.TabContent.map((item, j) => {
                            return (
                              <MenuItem
                                onClick={() => this.handleMenu(item)}
                                activeSortBy={activeSortBy}
                                text={item.title}
                                key={j}
                              >
                                {item.title}
                              </MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </div>
                    </MediaQuery>
                    <MediaQuery
                      query="(max-width: 767px)"
                      style={{ display: "none" }}
                    >
                      <div className="left_drop_box">
                        <DropdownButton title={activeTitle}>
                          {this.TabContent.map((item, j) => {
                            return (
                              <MenuItem
                                onClick={() => this.handleMenu(item)}
                                activeSortBy={activeSortBy}
                                text={item.title}
                                key={j}
                              >
                                {item.title}
                              </MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </div>
                    </MediaQuery>
                    <MediaQuery query="(min-width: 768px)">
                      <div className="left_scr_box">
                        <form id="demo-2">
                          <input
                            type="search"
                            placeholder="Search"
                            onChange={(e) => this.handleSearch(e)}
                            value={this.state.activeKeyword}
                          />
                        </form>
                      </div>
                    </MediaQuery>
                    <MediaQuery
                      query="(max-width: 767px)"
                      style={{ display: "none" }}
                    >
                      <div className="left_scr_box"></div>
                    </MediaQuery>
                  </div>
                  <div className="insights_mid_section">
                    <div className="row">
                      <MediaQuery query="(min-width: 768px)">
                        <div className="col-lg-3 col-md-3">
                          <div id="sticky-anchor"></div>
                          <div className="insights_left_listing">
                            <div className="insights_left_listing_text">
                              <div className="left_listing_card left_listing_card--feature">
                                <div className="listing_t1">
                                  <span>Interview&nbsp;</span>
                                  &#8226; 13 August 2021
                                </div>
                                <div className="listing_t2">
                                Vested in Innovation
                                </div>
                                <div className="listing_t3">
                                Priya Rajan of Silicon Valley Bank
                                </div>
                              </div>
                              <div className="left_listing_card--feature__el1"></div>
                              {isSearching ? (
                                <div style={{ margin: "10% 25% 10%" }}>
                                  <ClipLoader
                                    color={"#22316B"}
                                    loading={isSearching}
                                  />
                                </div>
                              ) : leftList.length ? (
                                leftList.slice(0, 27).map((item, i) => {
                                  return (
                                    <div className="left_listing_card" key={i}>
                                      <Link
                                        to={`/insights/${item.url.replace(
                                          /[^A-Z0-9]+/gi,
                                          ""
                                        )}`}
                                      >
                                        <div className="listing_t1">
                                          <span>{item.type}&nbsp;</span>
                                          &#8226; {item.date}
                                        </div>
                                        <div className="listing_t2">
                                          {item.ltitle}
                                        </div>
                                        <div className="listing_t3">
                                          {item.lname}
                                        </div>
                                      </Link>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="no__product">
                                  Not available in the list
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </MediaQuery>
                      <MediaQuery
                        query="(max-width: 767px)"
                        style={{ display: "none" }}
                      >
                        <div className="col-lg-3 col-md-3">
                          <div id="sticky-anchor"></div>
                          <div className="insights_left_listing"></div>
                        </div>
                      </MediaQuery>
                      <div className="col-lg-9 col-md-9">
                        <ScrollAnimation
                          delay={0}
                          duration={2}
                          animateIn="slideInRight"
                          offset={600}
                        >
                          <div className="insights_right_text">
                            <div className="insights_blog_page">
                              <div className="back_event">
                                <Link to="/insights">
                                  <i className="fa fa-arrow-left">
                                    {" "}
                                    browse Insights
                                  </i>
                                </Link>
                              </div>
                              <div className="insights_blog_text">
                                {this.Speaker.map((item, i) => {
                                  return (
                                    <div className="row">
                                      <ScrollAnimation
                                        delay={0}
                                        duration={1}
                                        animateIn="zoomIn"
                                        offset={100}
                                      >
                                        <div className="col-md-5 col-sm-6">
                                          <div
                                            className="right_img_section"
                                            onClick={() =>
                                              this.togglePopUp(item)
                                            }
                                          >
                                            <img
                                              src={item.imgUrl}
                                              alt="priya rajan"
                                              className="img-responsive"
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-7 col-sm-6">
                                          <div className="right_name_section">
                                            <div className="r_head">
                                              {item.head}
                                            </div>
                                            <div className="r_name">
                                              {item.name}
                                            </div>
                                            <div className="r_post">
                                            Market Lead for India and MENA, Silicon Valley Bank
                                            </div>
                                            <div className="r_block">
                                              <span>INTERVIEW</span> &#8226; 6
                                              mins read
                                            </div>
                                          </div>
                                          <div className="share_section_one">
                                            <div className="headsocialLink">
                                              <span className="hicon">
                                                <a
                                                  href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <button
                                                  style={{
                                                    display: "block !important",
                                                    width: "25px",
                                                  }}
                                                  className="forwardMail"
                                                  title="Forward to email"
                                                  onClick={
                                                    this.toggleMailShareForm
                                                  }
                                                >
                                                  <img
                                                    src={emailForwardIcon}
                                                    alt=""
                                                  />
                                                </button>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </ScrollAnimation>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="insights_blog_text_btm">
                                <div className="text_section">
                                  <div className="into_text">
                                  Priya Rajan has been at the heart of global innovation for more than a decade, leading global finance operations for Silicon Valley Bank. Having witnessed its evolution across markets and regions, she shares her insights into what drives entrepreneurial success and why the Indian VC market is exciting for investors. 



                                  </div>
                                  <div className="interview_vieo_section">
                                    <div className="interview_video">
                                      <div className="r_text_Q">
                                       <b> “Success stories such as Freshworks, Druva, Postman, Browserstack, Darwinbox, Razorpay, Innovacer, Uniphore, and several others have amplified the Indian startup ecosystem’s momentum. I expect global investor confidence will continue to increase and that investment dollars will continue to flow into the region. Founder, market, and investor maturity is visible and adds to the ease / fluidity / success of global businesses from India. We are going to see this exciting trend continue for years to come.”</b><br/><br/>
                                      </div>
                                     
                                    </div>
                                  </div>
                                  <div className="r_text_Q">
                                  Q1. You have led the operations of SVB a long time and expanded its global footprint. What has
been the most exciting part of your journey and what has been a constant and differential in
your approach?
                                  </div>
                                  <div className="r_text">
                                  I am truly grateful to be a part of an organization that has been the core of global
innovation for the last 14 years. In my first eight years of leading global finance operations, I
had this unique opportunity to help expand SVB’s global footprint. Over the last six years, I
have worked directly with start-ups and funds in the US/Northern California and Global
Markets (India and MENA). The hustle and passion of the global innovation ecosystem for
creating and investing in what’s next, is awe-inspiring. Being curious is vital and has been
consistent across the roles I have taken on. As I am interacting with my global clients
building cross-border SaaS solutions, organic baby products, blockchain or micro satellites,
my approach is to be curious, listen, learn, and adapt with an aim to create value beyond
banking.
<br/> 
                                  </div>
                                  <div className="r_text_Q">
                                  Q2. In your experience of leading and scaling SVB, have you ever faced a circumstance wherein
your decision making was questioned by your team or other stakeholders? What is your
mantra in handling such situations?
                                  </div>
                                  <div className="r_text">
                                  My approach to decision-making has evolved over the years. The problem that is needed to
be solved dictates the nuances to the process in most cases. It is critical at the end of the day
that we prioritize our clients, employees, and shareholders first. We are a mission-driven
organization guided by our values - empathy for others, speaking and acting with integrity,
embracing diverse perspectives, taking responsibility, and most importantly, keeping
learning and improving. When the priorities are clear, usually, the decisions tend to be more
apparent.<br/>  
                                </div>
                                <div className="r_text_Q">
                                  Q3. You have been associated with organizations like Big Brothers Big Sisters and Women Who
Code, organisations which groom women in technology. What is the one thing that women
entrepreneurs struggle with the most and what advice do you give them for maximum
impact?
                                  </div>
                                  <div className="r_text">
                                  Women, in general (me included), are perfectionists. We want to achieve/deliver 150% to
represent us at 100%. Our hesitation in putting ourselves out there until we feel ready puts
us behind the race from the start. “Believing in yourself” is the first step. The confidence and
approach of women entrepreneurs are changing for the better. Initiatives such as Neythri,
CXXO by Kaalari, TiE Women, and several others are working tirelessly to help bridge the
gap, empower women entrepreneurs and investors and inspire others to support this much-
needed movement.<br/>  
   

                                      </div>
                                 <div className="r_text_Q">
                                  Q4. What has been SVB&#39;s approach with women entrepreneurs? How has SVB addressed some
of the unconscious bias when it comes to fund raising by women entrepreneurs?
                                  </div>
                                  <div className="r_text">
                                  Black and Latinx individuals and women remain underrepresented in the innovation
economy, especially in leadership roles as executives, board members, investors and startup
founders. SVB’s Access to Innovation program was launched to help build a more diverse,
equitable and accessible innovation economy.  SVB has been at the center of innovation for
nearly 40 years, and has the networks, the expertise and the perspective to help accomplish
this goal. Together with our partners, we are building broader talent pipelines at all levels;
providing access to resources and training; making funds available to entrepreneurs and investors; and opening up networks to those who have been excluded. <br/> For more
information, visit <a href="https://www.svb.com/about-us/living-our-values/access-to-innovation">https://www.svb.com/about-us/living-our-values/access-to-innovation</a><br/> 


                                </div>
                                <div className="r_text_Q">
                                  Q5.What has been some of the differences in the way gender diversity is viewed in India and
US? What are some best organisational practices that India can learn from US in gender
diversity?
                                  </div>
                                  <div className="r_text">
                                  Diversity is a global issue. According to the Q1 Venture Monitor, VCs invested $10B in
companies with at least one female founder across 675 deals in Q1 2021 ($22.1B in 2020),
and nearly a quarter of all VC deals went to companies with at least one female founder in
Q1 2021, consistent with 2020. While the data is trending in the right direction, we still have
a long way to go.<br/>
Gender diversity in India is significantly behind when compared to the US – number of
female founders/co-founders, number of female investors (GPs), number of women on
boards. $/# of deals invested in women, women-focused funds /accelerators/support
groups, etc. Awareness of the issue and prioritizing the problem to implement the right
solutions are two critical steps that will help India develop a more diverse innovation
economy.
         <br/>  
                                 </div>
                                 <div className="r_text_Q">
                                  Q6. Please share your experience and lessons on how start-ups can build culturally diverse
teams.
                                  </div>
                                  <div className="r_text">

                                  Adversity drives innovation. A growing number of companies are adding inclusion and
diversity strategy as a part of their growth plans to ensure they are building culturally
diverse, strong teams. To help solve the DEI challenge, several start-ups help provide
organizations the right tools for accountability and decision-making, including Talenya,
Textio, Kanarys, Handshake, The Mom Project, Flockjay, and many more.  <br/>  

                                  </div>
                                 
                              
                                   

                                  <div className="r_text_Q">
                                  Q7. Quick Fire Questions:
                                  </div>
                                  <div className="r_text">
                                 
                                 <ul style={{marginTop:"-4px"}}> <li>	<b><i>Women need high technical skills to grow as a founder in Silicon Valley </i></b><br/>    
                                 Skill sets for a successful founding team (globally) vary from domain knowledge,
experience, growth mindset, ability to attract the right talent, etc. Right skills are
dependent on what you are building and the problem you are looking to solve. The
founding team should have the core skillsets to solve the problem.   <br/>   
 
</li>
<li><b><i> Intersection of identity, for instance being an Indian woman founder overseas (and
impact on investing decisions)    </i></b><br/>   
My advice for South Asian Female founders looking to fund raise/expand in global
markets – focus on the market, the product and differentiated value. Leverage
community support that is available such as Neythri, TiE Women etc. to help build a
network that will benefit you personally and professionally. </li>
<li><b><i>  	Building global businesses from India  </i></b> <br/>   
Success stories such as Freshworks, Druva, Postman, Browserstack, Darwinbox,
Razorpay, Innovacer, Uniphore, and several others have amplified the Indian startup
ecosystem’s momentum. I expect global investor confidence will continue to
increase and that investment dollars will continue to flow into the region. Founder,
market, and investor maturity is visible and adds to the ease / fluidity / success of
global businesses from India. We are going to see this exciting trend continue for
years to come.</li>
<li><b><i>   	3 lessons for start-ups in maintaining sustainable growth </i></b> <br/>   
<ul><li> Cash is King. Strategize when, from who, and how much to raise, balancing debt
vs. equity. </li> 
<li> Choose your partners wisely - investors, co-founders, mentors, advisors, etc.</li>
<li>Expanding into a new market? Understand the nuances related to its unique go-
to-market approaches and build local teams to drive its growth. </li></ul></li>
<li><b><i>  3 favourite women entrepreneurs and why </i></b> <br/>   
<ul><li>Vani Kola – Founder, Kalaari Capital - One of India’s few female GPs and a great
example of what “hustle and believing in their mission could result in.”  </li>
<li>Shradha Sharma – Founder, Yourstory – Shradha is a top global media influencer
today. Watching her go through peaks and valleys while building Yourstory was
inspirational. Shradha’s authentic can-do attitude motivates me to never to
give up.   </li>
<li>Lakshmi Pratury – Founder, INK – Her vision for creating a platform for
innovation in India at the intersection of science, technology, community, and
culture is forward-thinking, and her passion is highly contagious. Future leaders
across diverse spectrums are being created at INK daily. I got a glimpse of those
talents in person at the annual retreat at Jaisalmer a few years back.</li>
</ul>
</li>
<li><b><i>  	Favourite emerging technology </i></b> <br/>   
Not emerging but trending – AI and ML. There is still a ton of innovation that is
expected in the next several years.</li>
<li><b><i>  	Favourite holiday destination in India  </i></b> <br/>   
Jaisalmer (Thanks INK Retreat!)</li>
<li><b><i>  Favourite sport or work out technique</i></b> <br/>   
Zumba. I would never miss my Monday class at Clubsport.</li>
</ul> 
                                  </div>
                                  <div className="r_text_Q"></div>
                                  <div className="r_text_Q"></div>
                                  {/* <div className="r_text">
                                    <div
                                      className="para"
                                      style={{ padding: "20px 0px 0px 0px" }}
                                    >
                                      <i>Interviewed by Sreeja Vasantham</i>
                                    </div>
                                  </div> */}
                                </div>
                                <div className="footer_sm_icon">
                                  <div className="headsocialLink">
                                    <span className="hicon">
                                      <a
                                        href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                        style={{ display: "block !important" }}
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <a
                                        style={{ display: "block !important" }}
                                        href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <a
                                        style={{ display: "block !important" }}
                                        href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <button
                                        style={{
                                          display: "block !important",
                                          width: "25px",
                                        }}
                                        className="forwardMail"
                                        title="Forward to email"
                                        onClick={this.toggleMailShareForm}
                                      >
                                        <img src={emailForwardIcon} alt="" />
                                      </button>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="back_event">
                                <Link to="/insights">
                                  <i className="fa fa-arrow-left">
                                    {" "}
                                    browse Insights
                                  </i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </ScrollAnimation>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
            </div>
          </div>
        </ContentPage>
      </div>
    );
  }
}
PriyaRajan.propTypes = {
  location: PropTypes.object,
};

export default PriyaRajan;



// WEBPACK FOOTER //
// ./src/pages/insights/PriyaRajan.js